import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Merge Tailwind class names, with later classes winning conflicts.
 *
 * Always route conditional classes through this — never string-concatenate,
 * and never build a class from a variable fragment (`text-${c}-500`), because
 * Tailwind's scanner reads source text and cannot see it.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
